export enum I18nNotifications {
  common = 'notifications',
}
